<template>
  <div id="paper-element">
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item>
          <el-button type="primary" @click="addFormVisible = true" v-if="roles.indexOf('1')>-1">新增</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page" :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:left;">
      </el-pagination>
    </el-col>

    <!-- 列表 -->
    <el-table :data="infos" border v-loading="listLoading" style="width: 780px">
      <el-table-column prop="name" label="名称" width="100px">
      </el-table-column>
      <el-table-column prop="innerD" label="内径(mm)" width="148px">
      </el-table-column>
      <el-table-column prop="outerD" label="外径(mm)" width="148px">
      </el-table-column>
      <el-table-column prop="weight" label="重量(kg)" width="148px">
      </el-table-column>
      <el-table-column prop="width" label="宽度(mm)" width="148px">
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <!-- <el-button size="small" type="text" @click="showEdit(scope.row)">编辑</el-button> -->
          <el-button type="text" size="small" @click="doDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 新增界面-->
    <el-dialog title="新增" :visible.sync="addFormVisible" :close-on-click-modal="false" width="26%">
      <el-form :model="addForm" label-width="100px" ref="addForm" @submit.native.prevent>
        <el-form-item label="名称" prop="name">
          <el-input v-model="addForm.name"></el-input>
        </el-form-item>
        <el-form-item label="内径(mm)" prop="innerD">
          <el-input v-model="addForm.innerD" type="number"></el-input>
        </el-form-item>
        <el-form-item label="外径(mm)" prop="outerD">
          <el-input v-model="addForm.outerD" type="number"></el-input>
        </el-form-item>
        <el-form-item label="重量(kg)" prop="weight">
          <el-input v-model="addForm.weight" type="number"></el-input>
        </el-form-item>
        <el-form-item label="宽度(mm)" prop="width">
          <el-input v-model="addForm.width" type="number"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click="doAdd" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      postApi: {
        crud: "",
        info: {}
      },

      page: 1, //分页显示信息
      total: 0,
      pageSize: 10,
      infos: [],
      pageSizes: [10, 20, 30, 40],

      id: "", //查询数据
      message: {
        result: {
          infos: []
        }
      },

      addFormVisible: false, //显示新增界面
      addLoading: false,
      addForm: {
        name: "",
        innerD: "",
        outerD: "",
        weight: "",
        width: ""
      }
    };
  },
  created: function() {
    this.doSelect();
  },
  methods: {
    //新增
    doAdd: async function() {
      if (
        this.addForm.weight === "" ||
        this.addForm.width === "" ||
        this.addForm.name === "" ||
        this.addForm.innerD === "" ||
        this.addForm.outerD === ""
      ) {
        this.$message.error("不能有空白数据");
      } else if (
        Number(this.addForm.weight) < 0 ||
        Number(this.addForm.width) < 0 ||
        Number(this.addForm.innerD) < 0 ||
        Number(this.addForm.outerD) < 0
      ) {
        this.$message.error("数值不能为负值");
      } else {
        this.$confirm("确认提交吗？", "提示", {}).then(async () => {
          this.postApi.crud = "c";
          this.postApi.info = this.addForm;
          this.addLoading = true;
          let res = await this.$doPost(
            "/api/basedata/paperelement",
            this.postApi
          );
          this.addLoading = false;
          if (res.msgCode === 0) {
            this.$message({
              message: "添加成功!",
              type: "success"
            });
            this.id = "";
            this.doSelect();
            this.addForm.name = this.addForm.innerD = this.addForm.outerD = this.addForm.weight = this.addForm.width =
              "";
          } else {
            this.$message.error({
              message: res.msg
            });
          }
          this.addFormVisible = false;
        });
      }
    },
    //查询
    doSelect: async function() {
      this.postApi.crud = "r";
      this.listLoading = true;
      this.message = await this.$doPost(
        "/api/basedata/paperelement",
        this.postApi
      );
      this.total = this.message.result.infos.length;
      this.getPageInfo();
      this.listLoading = false;
    },
    //删除
    doDelete: function(row) {
      this.$confirm("将永久删除 " + row.name + ", 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          this.postApi.crud = "d";
          this.postApi.info = {
            key: row.name
          };
          let res = await this.$doPost(
            "/api/basedata/paperelement",
            this.postApi
          );
          if (res.msgCode === 0) {
            this.$message({
              type: "success",
              message: "删除成功"
            });
            this.id = "";
            this.doSelect();
          } else {
            this.$message.error("删除失败");
          }
        })
        .catch(() => {
          this.$message.error("删除失败");
        });
    },
    //分页
    handleCurrentChange(val) {
      this.page = val;
      this.getPageInfo();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getPageInfo();
    },
    getPageInfo() {
      this.infos = [];
      for (
        let i = this.pageSize * (this.page - 1);
        i < this.pageSize * this.page;
        i++
      ) {
        if (i == this.message.result.infos.length) break;
        this.infos.push(this.message.result.infos[i]);
      }
    }
  },
  props: {
    roles: Array
  }
};
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/basedata/PaperElement.vue